import React, { useEffect, useState } from "react";
import Card from "@material-tailwind/react/Card";
import { toast } from "react-toastify";

import Skeltons from "../../../../components/loading/Skeltons";
import { Colors } from "../../../../assets/Colors";
import { getOutstandingLaporan, rupiah, teksSisaLPD, tglIndo } from "./perjalananDinasApi";

// Monitoring SLA: pengajuan Selesai yang laporan (LPD)-nya belum Selesai. Batas = 7 hari kerja
// setelah tanggal selesai (Senin–Jumat, minus hari libur terdaftar di MHoliday).
const LpdTrackerPage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [saring, setSaring] = useState("semua");

  const muat = async (q = "") => {
    setLoading(true);
    try {
      setRows(await getOutstandingLaporan(q));
    } catch (e) {
      toast.error(e.message, { position: "bottom-right" });
    }
    setLoading(false);
  };
  useEffect(() => {
    muat("");
  }, []);

  const terlambat = rows.filter((r) => r.SisaHariLPD < 0);
  const mendesak = rows.filter((r) => r.SisaHariLPD >= 0 && r.SisaHariLPD <= 2);
  const tampil = saring === "terlambat" ? terlambat : saring === "mendesak" ? mendesak : rows;

  const Kartu = ({ judul, nilai, warna, pilih }) => (
    <button
      onClick={() => setSaring(pilih)}
      className={`text-left border rounded px-4 py-3 ${saring === pilih ? "ring-2 ring-main-100" : ""} bg-white`}
    >
      <div className="text-xs uppercase text-gray-500 font-bold">{judul}</div>
      <div className={`text-2xl font-bold ${warna}`}>{nilai}</div>
    </button>
  );

  return (
    <div className="md:ml-64">
      <div style={{ background: Colors.primary }} className="pt-14 pb-16 px-3 md:px-8 h-auto" />
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              {loading ? (
                <Skeltons />
              ) : (
                <>
                  <div className="px-4 pt-4">
                    <h2 className="text-lg font-bold text-gray-800">Monitoring Laporan Perjalanan Dinas (LPD)</h2>
                    <p className="text-sm text-gray-500">
                      Perjalanan dinas yang sudah disetujui tetapi laporannya belum selesai. Batas: 7 hari kerja setelah perjalanan selesai.
                    </p>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 px-4 pt-3">
                    <Kartu judul="Belum selesai" nilai={rows.length} warna="text-gray-800" pilih="semua" />
                    <Kartu judul="Terlambat" nilai={terlambat.length} warna="text-red-600" pilih="terlambat" />
                    <Kartu judul="Batas ≤ 2 hari kerja" nilai={mendesak.length} warna="text-amber-600" pilih="mendesak" />
                  </div>
                  <div className="px-4 pt-3">
                    <input
                      type="text"
                      placeholder="Cari ID / NIK / nama / tujuan (Enter)"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && muat(search)}
                      className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-96"
                    />
                  </div>
                  <div className="overflow-x-auto px-4 py-4">
                    <table className="table-auto w-full text-sm text-left text-gray-500">
                      <thead className="text-xs text-orange-600 uppercase bg-gray-50">
                        <tr>
                          {["ID", "Karyawan", "Tujuan", "Selesai", "Batas LPD", "Sisa", "Status LPD", "Selisih"].map((h) => (
                            <th key={h} className="py-3 px-4">
                              {h}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {tampil.length === 0 ? (
                          <tr>
                            <td colSpan={8} className="text-center py-8 text-gray-400">
                              Tidak ada laporan yang tertunda
                            </td>
                          </tr>
                        ) : (
                          tampil.map((r, i) => (
                            <tr key={r.PerjalananDinasID} className={i % 2 === 0 ? "bg-gray-50 border-b" : "bg-white border-b"}>
                              <td className="py-3 px-4 font-mono text-xs">{r.PerjalananDinasID}</td>
                              <td className="py-3 px-4">
                                {r.NamaKaryawan}
                                <div className="text-xs text-gray-400">{r.NamaBagian}</div>
                              </td>
                              <td className="py-3 px-4">{r.Tujuan}</td>
                              <td className="py-3 px-4 whitespace-nowrap">{tglIndo(r.TanggalSelesai)}</td>
                              <td className="py-3 px-4 whitespace-nowrap">{tglIndo(r.BatasLPD)}</td>
                              <td
                                className={
                                  "py-3 px-4 whitespace-nowrap font-semibold " +
                                  (r.SisaHariLPD < 0 ? "text-red-600" : r.SisaHariLPD <= 2 ? "text-amber-600" : "text-gray-600")
                                }
                              >
                                {teksSisaLPD(r)}
                              </td>
                              <td className="py-3 px-4">{r.LaporanStatusKet}</td>
                              <td className="py-3 px-4 whitespace-nowrap">{r.LaporanID ? rupiah(r.Selisih) : "-"}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LpdTrackerPage;
